<app-header></app-header>
<section class="unauthorized_page">
  <div *ngIf="!isProfile" class="student_column">
    <h1>
      <a [routerLink]="['/student']" style="cursor: pointer">
        Я ученик
      </a>
    </h1>
  </div>
</section>
